export const DATE_FORMATS = {
  dateTime: "MMM D, YYYY HH:mm:ss",
  month: "MMM",
  monthDay: "MMM DD",
  monthDayShort: "MMM D",
  monthDayYear: "MMM DD, YYYY",
  monthYear: "MMMM YYYY",
  monthYearShort: "MMM YYYY",
  time: "HH:mm",
  weekdayMonthDayShort: "ddd, MMM D",
  yearMonthDay: "YYYY-MM-DD"
} as const;

export type DateFormatKey = keyof typeof DATE_FORMATS;
